export default "__VITE_ASSET__C4avO10G__"